import { throttle } from "lodash";

const scrollToTop = document.querySelector(".scroll-to-top");
let lastKnownScrollPosition = 0;

if (scrollToTop !== null) {
  document.addEventListener('scroll', (e) => {
    lastKnownScrollPosition = window.scrollY;
    throttle(
      function () {
        if (lastKnownScrollPosition >= window.innerHeight) {
          scrollToTop.classList.add("active");
        } else {
          scrollToTop.classList.remove("active");
        }
      },
      100,
      { leading: true, trailing: true }
    )
  });
}